/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  FormFieldType,
  IFormInput,
  IFormValidatable,
  RequiredValidations,
} from '../typings';
import { BaseFormFieldBuilder } from '.';

type Validations = RequiredValidations<IFormInput['validations']>;

export class InputFormFieldBuilder
  extends BaseFormFieldBuilder<IFormInput>
  implements IFormValidatable<Validations>
{
  // @ts-ignore
  private _type = FormFieldType.Input as const;
  // @ts-ignore
  private _inputType?: IFormInput['inputType'];
  // @ts-ignore
  private _mask?: IFormInput['mask'];
  // @ts-ignore
  private _showClearButton?: IFormInput['showClearButton'];
  // @ts-ignore
  private _suggestedValues?: IFormInput['suggestedValues'];
  private _validations?: Validations;

  constructor() {
    super();
  }

  public validation(value: Validations[number]): this {
    if (this._validations) {
      this._validations.push(value);
    } else {
      this._validations = [value];
    }

    return this;
  }

  public validations(value: Validations): this {
    if (this._validations) {
      this._validations.push(...value);
    } else {
      this._validations = [...value];
    }

    return this;
  }

  public inputType(value: IFormInput['inputType']): this {
    this._inputType = value;

    return this;
  }

  public mask(value: IFormInput['mask']): this {
    this._mask = value;

    return this;
  }

  public showClearButton(value: IFormInput['showClearButton']): this {
    this._showClearButton = value;

    return this;
  }

  public suggestedValues(value: IFormInput['suggestedValues']): this {
    this._suggestedValues = value;

    return this;
  }
}
